import ResumeItem from "@/common/components/ResumeItem";
import Rows from "@/common/components/Table/rows";
import { formatCurrency } from "@/common/utils/formatters";
import { branchesEquipmentsConsumptionsTotalizerColumns } from "@/features/movementsTotalizer/constants/branchesEquipmentsConsumptionsTotalizerColumns.constant";
import { BranchesEquipmentsConsumptionsTotalizerTransformer } from "@/features/movementsTotalizer/services/branchesEquipmentsConsumptionsTotalizerTransformer";
import { BranchesEquipmentsConsumptionsTotalizerEquipmentData } from "@/features/movementsTotalizer/types/branchesEquipmentsConsumptionsTotalizer.type";
import { CarFrontIcon } from "lucide-react";

interface EquipmentRowProps {
  equipment: BranchesEquipmentsConsumptionsTotalizerEquipmentData;
}

const EquipmentRow = ({
  equipment,
}: EquipmentRowProps) => {
  return (
    <>
      <tr>
        <td colSpan={branchesEquipmentsConsumptionsTotalizerColumns.length} className="p-0 print:border-x print:border-neutral-200">
          <div className="flex items-center justify-between gap-8 p-3 bg-white-200/15 print:bg-neutral-200">
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-3">
                <CarFrontIcon strokeWidth={1.5} size={22} className="text-blue-800 print:text-black" />

                <ResumeItem
                  label="Equipamento"
                  value={equipment.field_value_for_display}
                  className="print:font-medium"
                  labelClassName="text-xs print:text-black"
                  valueClassName="text-sm print:text-black"
                />
              </div>

              <ResumeItem
                label="Modelo"
                value={equipment.model_name || '--'}
                className="print:font-medium"
                labelClassName="text-xs print:text-black"
                valueClassName="text-sm print:text-black"
              />

              <ResumeItem
                label="Ano"
                value={equipment.fabrication_year?.toString() || '--'}
                className="print:font-medium"
                labelClassName="text-xs print:text-black"
                valueClassName="text-sm print:text-black"
              />
            </div>
          </div>
        </td>
      </tr>

      <Rows
        className="text-sm print:border-b"
        columnClassName="bg-white-100 first:border-l-0 last:border-r-0 print:first:border-l print:last:border-r print:border-neutral-200"
        data={BranchesEquipmentsConsumptionsTotalizerTransformer.productsTableTransformer()(equipment.products || [])}
        columns={branchesEquipmentsConsumptionsTotalizerColumns}
        isLoading={false}
        loadingRows={0}
        showEmptyTable={false}
        emptyValue="--"
        EmptyTable={(
          <div className="py-4 bg-blue-100/5 p-0 flex items-center justify-center print:border-x print:border-neutral-200">
            <p className="italic text-white-400 print:text-black">
              Não possui nenhum registro para esse equipamento
            </p>
          </div>
        )}
      />

      <tr>
        <td colSpan={branchesEquipmentsConsumptionsTotalizerColumns.length} className="p-0 print:border-x print:border-neutral-200">
          <div className="flex items-center justify-between gap-8 p-3 bg-white-200/10 print:bg-neutral-200/50 print:font-medium">
            <p className="">
              Valor total do equipamento
            </p>

            <p>
              {(equipment.total_value && formatCurrency(Number(equipment.total_value))) || '--'}
            </p>
          </div>
        </td>
      </tr>
    </>
  );
}

export default EquipmentRow;
